import type { GameMode, Vec2 } from '../core/types';

interface DebugData {
  fps: number;
  dt: number;
  activeMeshes: number;
  mode: GameMode;
  elapsed: number;
  tilt: Vec2;
  rawTilt: Vec2;
  ballSpeed: number;
  planarSpeed: number;
  angularSpeed: number;
  slipRatio: number;
}

/**
 * Debug overlay showing FPS, draw calls, and game state.
 */
export class DebugOverlay {
  private element: HTMLElement;
  private _visible = true;

  constructor(element: HTMLElement) {
    this.element = element;
  }

  get visible(): boolean {
    return this._visible;
  }

  set visible(v: boolean) {
    this._visible = v;
    this.element.classList.toggle('hidden', !v);
  }

  update(data: DebugData): void {
    if (!this._visible) return;

    const tiltStr = `${data.tilt.x.toFixed(2)}, ${data.tilt.y.toFixed(2)}`;
    const rawStr = `${data.rawTilt.x.toFixed(2)}, ${data.rawTilt.y.toFixed(2)}`;
    const timeStr = data.elapsed.toFixed(2);

    // Slip interpretation: <0.2 rolling, 0.2-0.6 mixed, >0.6 sliding
    const slipLabel = data.slipRatio < 0.2 ? 'roll' : data.slipRatio < 0.6 ? 'mix' : 'slide';

    this.element.innerHTML = `
FPS: ${data.fps}
Mode: ${data.mode}
Time: ${timeStr}s
Tilt: ${tiltStr}
Raw: ${rawStr}
Planar: ${data.planarSpeed.toFixed(2)} | Ang: ${data.angularSpeed.toFixed(1)}
Slip: ${data.slipRatio.toFixed(2)} (${slipLabel})
    `.trim();
  }
}
